"use client";
import { jsx, jsxs } from "react/jsx-runtime";
import { cn } from "../utils.js";
import * as __rspack_external_react from "react";
import * as __rspack_external__radix_ui_react_tooltip_b301f25d from "@radix-ui/react-tooltip";
const TooltipProvider = __rspack_external__radix_ui_react_tooltip_b301f25d.Provider;
const Tooltip = __rspack_external__radix_ui_react_tooltip_b301f25d.Root;
const TooltipTrigger = __rspack_external__radix_ui_react_tooltip_b301f25d.Trigger;
const TooltipArrow = (props)=>/*#__PURE__*/ jsx(__rspack_external__radix_ui_react_tooltip_b301f25d.Arrow, {
        className: "tw-block tw-fill-neutral-dark-700 dark:tw-fill-neutral-light-200",
        ...props
    });
TooltipArrow.displayName = __rspack_external__radix_ui_react_tooltip_b301f25d.Arrow.displayName;
const TooltipContent = /*#__PURE__*/ __rspack_external_react.forwardRef(({ className, sideOffset = 15, children, ...props }, ref)=>/*#__PURE__*/ jsxs(__rspack_external__radix_ui_react_tooltip_b301f25d.Content, {
        ref: ref,
        sideOffset: sideOffset,
        className: cn('tw-relative tw-bg-neutral-dark-700 tw-rounded-0.4 tw-max-w-28 dark:tw-bg-neutral-light-200 tw-text-center tw-font-body5 tw-font-normal tw-text-neutral-light-100 dark:tw-text-neutral-light-800 tw-p-0.8 data-[side=bottom]:tw-slide-in-from-top-2 tw-z-5 tw-animate-in tw-fade-in-0 tw-zoom-in-95 data-[state=closed]:tw-animate-out data-[state=closed]:tw-fade-out-0 data-[state=closed]:tw-zoom-out-95 data-[side=left]:tw-slide-in-from-right-2 data-[side=right]:tw-slide-in-from-left-2 data-[side=top]:tw-slide-in-from-bottom-2 tw-whitespace-normal', className),
        ...props,
        children: [
            /*#__PURE__*/ jsx(TooltipArrow, {}),
            children
        ]
    }));
TooltipContent.displayName = __rspack_external__radix_ui_react_tooltip_b301f25d.Content.displayName;
const TooltipWrapper = ({ delayDuration, children, side, value, asChild, align })=>/*#__PURE__*/ jsx(TooltipProvider, {
        children: /*#__PURE__*/ jsxs(Tooltip, {
            delayDuration: delayDuration,
            children: [
                /*#__PURE__*/ jsx(TooltipTrigger, {
                    asChild: asChild,
                    children: children
                }),
                /*#__PURE__*/ jsx(TooltipContent, {
                    align: align,
                    side: side,
                    children: value
                })
            ]
        })
    });
const SimpleTooltip = ({ value, children, side, align = 'center', delayDuration, asChild = true, className })=>/*#__PURE__*/ jsx(TooltipProvider, {
        children: /*#__PURE__*/ jsxs(Tooltip, {
            delayDuration: delayDuration,
            children: [
                /*#__PURE__*/ jsx(TooltipTrigger, {
                    asChild: asChild,
                    children: children
                }),
                /*#__PURE__*/ jsx(TooltipContent, {
                    align: align,
                    side: side,
                    className: className,
                    children: value
                })
            ]
        })
    });
export { SimpleTooltip, Tooltip, TooltipArrow, TooltipContent, TooltipProvider, TooltipTrigger, TooltipWrapper };
